import { capitalizeString } from "core/helpers/utils";
import { useTranslation } from "react-i18next";
import { StatusModal } from "shared/UI/StatusModal/StatusModal";

interface MediaPermissionsModalProps {
  isVisible: boolean;
  onDismiss: () => void;
  requiredPermissions?: string[];
}

export const MediaPermissionsModal = ({ isVisible, onDismiss, requiredPermissions }: MediaPermissionsModalProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: "support.videoCall.mediaPermissions" });

  if (!isVisible || !requiredPermissions || !requiredPermissions.length) {
    return null;
  }

  const permission = requiredPermissions.join(" and ");

  return (
    <StatusModal
      data={{
        title: capitalizeString(t("title", { permission })),
        description: t("description", { permission }),
        cta: t("cta"),
      }}
      status="info"
      handleConfirm={onDismiss}
    />
  );
};
